import useConsulting from '@/pages/consulting/hooks/useConsulting';
import ConsultingTabContents from './ConsultingTabContents';
import SubVisual from '@/components/SubVisual';
import { ConsultingTab, ConsultingTabMap } from '@/pages/consulting/constants';
import { useEffect, useMemo } from 'react';
import ConsultingContact from './ConsultingContact';
import Accordion from '@/components/Accordion/Accordion';
import { useSearchParams } from 'react-router';

const maxButtons = 10;

const ConsultingPage = () => {
	const { formData, content, getCounsultingList, handleInputChange } = useConsulting();
	const tabData = ConsultingTabMap[formData.expertAskType as keyof typeof ConsultingTabMap];
	useEffect(() => {
		const hash = window.location.hash;
		const hashToType: Record<string, string> = {
			'#consulting': 'EXATYPE001',
			'#consulting2': 'EXATYPE002',
			'#consulting3': 'EXATYPE003',
			'#consulting4': 'EXATYPE004',
			'#consulting5': 'EXATYPE005',
			'#consulting6': 'EXATYPE006'
		};

		const fakeEvent = {
			target: {
				name: 'expertAskType',
				value: hash && hashToType[hash] ? hashToType[hash] : 'EXATYPE001'
			}
		} as React.ChangeEvent<HTMLInputElement>;
		handleInputChange(fakeEvent);
	}, []);

	const startPage = useMemo(
		() => Math.floor(((content?.currentPage || 0) - 1) / maxButtons) * maxButtons + 1,
		[content]
	);
	const endPage = useMemo(() => Math.min(startPage + maxButtons - 1, content?.totalPage || 0), [content]);
	const pages = useMemo(() => {
		if (!content) return [];
		const arr = [];
		for (let i = startPage; i <= endPage; i++) {
			arr.push(i);
		}
		return arr;
	}, [content, startPage, endPage]);

	return (
		<main id="sub" className="sub consulting">
			<SubVisual cate={ConsultingTab.cate} title={ConsultingTab.title}>
				<div className="sub-visual-tab radio">
					{[
						{ id: 'radio1', value: 'EXATYPE001', label: '세무', hash: '#consulting' },
						{ id: 'radio2', value: 'EXATYPE002', label: '결산', hash: '#consulting2' },
						{ id: 'radio3', value: 'EXATYPE003', label: '법무', hash: '#consulting3' },
						{ id: 'radio4', value: 'EXATYPE004', label: 'IP관리', hash: '#consulting4' },
						{ id: 'radio5', value: 'EXATYPE005', label: '노무', hash: '#consulting5' },
						{ id: 'radio6', value: 'EXATYPE006', label: '기술평가/기술특례상장', hash: '#consulting6' }
					].map(({ id, value, label, hash }) => (
						<label
							htmlFor={id}
							className="tab-btn"
							key={id}
							onClick={() => {
								window.location.hash = hash;
							}}>
							<input
								type="radio"
								id={id}
								name="expertAskType"
								value={value}
								checked={formData.expertAskType === value}
								onChange={handleInputChange}
							/>
							{label}
						</label>
					))}
				</div>
				<ConsultingTabContents
					addClass={`tab-content content${formData.expertAskType.replace('EXATYPE00', '')}`}
					title={tabData?.title ?? ''}
					desc={tabData?.desc ?? ''}
					infoDesc={tabData?.infoDesc ?? []}
					focusList={tabData?.focusList ?? []}
					focusDetail={tabData?.focusDetail ?? []}
					attentionList={tabData?.attentionList ?? []}
				/>
			</SubVisual>

			<ConsultingContact contactUs={tabData?.contactUs} />

			<section id="" className="sub-content inquiry">
				<div className="sub-inner">
					<strong className="title">
						문의내역
						<span className="desc">전문가문의는 서비스 가입 후 이용할 수 있습니다.</span>
					</strong>

					<Accordion items={content?.list ?? []} isFaq />

					{/* 페이지네이션은 별도 컴포넌트로 분리 권장 */}
					<div className="board-pagination">
						<button
							className="pagination-btn btn-prev"
							disabled={content?.currentPage === 1}
							onClick={() => getCounsultingList(formData.expertAskType, (content?.currentPage || 0) - 1)}></button>

						{pages.map(page => (
							<button
								key={page}
								className={`pagination-btn ${content?.currentPage === page ? 'active' : ''}`}
								onClick={() => getCounsultingList(formData.expertAskType, page)}>
								{page}
							</button>
						))}

						<button
							className="pagination-btn btn-next"
							disabled={content?.currentPage === 1 || content?.currentPage === content?.totalPage}
							onClick={() => getCounsultingList(formData.expertAskType, (content?.currentPage || 0) + 1)}></button>
					</div>
				</div>
			</section>
		</main>
	);
};

export default ConsultingPage;
